import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'
import storeHttp from '../utils/service/store'
import { bootGate } from '@/utils/gate'
import loader from '@/components/loader'
import {
	getDefaultPathByPermissions,
	hasAnyBackendOperation,
} from '@/utils/permission'
import {
	setPendingNavigationTarget,
	clearPendingNavigationTarget,
	handleChunkLoadError,
} from '@/utils/chunkErrorHandler'

const Home = () => import('../views/home/Home.vue')
const AccountManage = () => import('../views/accountManage/AccountManage.vue')
const UserInfo = () => import('../views/accountManage/UserInfo.vue')
const ResetPassword = () => import('../views/accountManage/ResetPassword.vue')
const StoreSet = () => import('../views/accountManage/StoreSet.vue')
const MobileOrderSet = () => import('../views/accountManage/MobileOrderSet.vue')
const InvoiceSet = () => import('../views/accountManage/InvoiceSet.vue')
const DeliveryPlatformSet = () =>
	import('../views/accountManage/DeliveryPlatformSet.vue')
const StoreManage = () => import('../views/storeManage/StoreManage.vue')
const AddStore = () => import('../views/storeManage/AddStore.vue')
const MangerContract = () => import('../views/storeManage/MangerContract.vue')
const StoreDetails = () => import('../views/storeManage/StoreDetails.vue')
const BusinessManage = () =>
	import('../views/businessManage/BusinessManage.vue')
const AddBusiness = () => import('../views/businessManage/AddBusiness.vue')
const BusinessDetails = () =>
	import('../views/businessManage/BusinessDetails.vue')
const SystemSetting = () => import('@/views/system/SystemSetting.vue')
const MenuManage = () => import('../views/menuManage/MenuManage.vue')
const Category = () => import('../views/menuManage/category/Category.vue')
const Taste = () => import('../views/menuManage/taste/Taste.vue')
const Upgrade = () => import('@/views/menuManage/upgrade/Upgrade.vue')
const Meals = () => import('../views/menuManage/meal/Meals.vue')
const Editor = () => import('../views/menuManage/meal/Editor.vue')
const OrderManage = () => import('../views/orderManage/OrderManage.vue')
const OrderDetails = () => import('../views/report/OrderDetails.vue')
const Report = () => import('../views/report/Report.vue')
const OrderManageList = () => import('../views/report/OrderManageList.vue')
const CashDrawerRecord = () => import('../views/report/CashDrawerRecord.vue')
const OrderManageSocket = () =>
	import('../views/orderManage/OrderManageSocket.vue')
const StorePos = () => import('../views/pos/StorePos.vue')
const Login = () => import('../views/Login.vue')
const SalesRanking = () => import('../views/report/SalesRanking.vue')
const BusinessStatement = () => import('../views/report/BusinessStatement.vue')
const Remark = () => import('@/views/menuManage/remark/Remark')
const AnnouncementManager = () =>
	import('../views/announcement/AnnouncementManager')
const Announcement = () =>
	import('../views/announcement/announcement/Announcement')
const AnnouncementEditor = () =>
	import('@/views/announcement/announcement/AnnouncementEditor')
const AnnouncementTemplate = () =>
	import('../views/announcement/announcementTemplate/AnnouncementTemplate')
const AnnouncementTemplateEditor = () =>
	import('@/views/announcement/announcementTemplate/AnnouncementTemplateEditor')
const StoreAnnouncementHistory = () =>
	import('@/views/announcement/storeAnnouncement/StoreAnnouncementHistory.vue')
const ContractClassification = () =>
	import('@/views/contractManage/ContractClassification')
const ContractManage = () => import('@/views/contractManage/ContractManage')
const AddContract = () => import('@/views/contractManage/AddContract')
const ContractDetails = () => import('@/views/contractManage/ContractDetails')
const MailHistory = () => import('@/views/mailHistory/MailHistory')
const AdminResetPassword = () =>
	import('@/views/accountManage/AdminResetPassword')
const UserAuthManage = () => import('../views/userAuthManage/UserAuthManage')
const UserManage = () =>
	import('../views/userAuthManage/userManage/UserManage.vue')
const UserEditor = () =>
	import('@/views/userAuthManage/userManage/UserEditor.vue')
const AuthManage = () =>
	import('../views/userAuthManage/authManage/AuthManage.vue')
const AuthEditor = () =>
	import('@/views/userAuthManage/authManage/AuthEditor.vue')

const WhatsEatManage = () => import('@/views/whatsEatManage/WhatsEatManage.vue')
const WhatsEatPanel = () => import('@/views/whatsEatManage/WhatsEatPanel.vue')
const NearlyExpired = () => import('@/views/nearlyExpired/NearlyExpired.vue')
const DevTools = () => import('@/views/devTools/DevTools.vue')

Vue.use(VueRouter)

export const adminRoutes = [
	{
		path: 'nearly-expired',
		name: 'NearlyExpired',
		icon: 'mdi-clock-outline',
		title: '30天內到期店家總覽',
		component: NearlyExpired,
		meta: {
			roles: [
				'ROLE_SUPER_SPECIAL_MANAGER',
				'USER_MANAGER',
				'USER_SALES_PERSON',
			],
		},
	},
	{
		path: 'store-manage',
		name: 'StoreManage',
		icon: 'mdi-home-outline',
		title: '店家管理',
		component: StoreManage,
		meta: {
			roles: [
				'ROLE_SUPER_SPECIAL_MANAGER',
				'USER_MANAGER',
				'USER_SALES_PERSON',
			],
		},
		children: [
			{
				path: 'add-store',
				name: 'StoreManageAddStore',
				component: AddStore /* webpackChunkName: "StoreManageAddStore" */,
				hide: true,
				meta: {
					roles: [
						'ROLE_SUPER_SPECIAL_MANAGER',
						'USER_MANAGER',
						'USER_SALES_PERSON',
					],
				},
			},
			{
				path: 'add-contract/:storeId',
				name: 'StoreManageMangerContract',
				component:
					MangerContract /* webpackChunkName: "StoreManageMangerContract" */,
				hide: true,
				meta: {
					roles: [
						'ROLE_SUPER_SPECIAL_MANAGER',
						'USER_MANAGER',
						'USER_SALES_PERSON',
					],
				},
			},
			{
				path: 'store-details/:storeId/:tabType',
				name: 'StoreManageStoreDetails',
				component:
					StoreDetails /* webpackChunkName: "StoreManageStoreDetails" */,
				hide: true,
				meta: {
					roles: [
						'ROLE_SUPER_SPECIAL_MANAGER',
						'USER_MANAGER',
						'USER_SALES_PERSON',
					],
				},
			},
		],
	},
	{
		path: 'business-manage',
		name: 'BusinessManage',
		icon: 'mdi-account-tie',
		title: '業務管理',
		component: BusinessManage,
		meta: {
			roles: ['ROLE_SUPER_SPECIAL_MANAGER', 'USER_MANAGER'],
		},

		children: [
			{
				path: 'add-business',
				name: 'BusinessManageAddBusiness',
				component:
					AddBusiness /* webpackChunkName: "BusinessManageAddBusiness" */,
				hide: true,
				meta: {
					roles: ['ROLE_SUPER_SPECIAL_MANAGER', 'USER_MANAGER'],
				},
			},
			{
				path: 'business-details/:businessId/:detailsType',
				name: 'BusinessManageBusinessDetails',
				component:
					BusinessDetails /* webpackChunkName: "BusinessManageBusinessDetails" */,
				hide: true,
				meta: {
					roles: ['ROLE_SUPER_SPECIAL_MANAGER', 'USER_MANAGER'],
				},
			},
		],
	},
	{
		path: 'store-pos',
		name: 'StorePos',
		icon: 'mdi-alarm-panel',
		title: 'POS 系統',
		component: StorePos /* webpackChunkName: "StorePos" */,
		meta: {
			roles: ['USER_STORE'],
		},
	},
	{
		path: 'order-manage',
		name: 'OrderManage',
		icon: 'mdi-cart-outline',
		title: '訂單管理',
		component: OrderManage,
		redirect: '/order-manage/socket',
		meta: {
			roles: ['USER_STORE'],
		},
		children: [
			{
				path: 'socket',
				name: 'OrderManageSocket',
				component: OrderManageSocket,
				hide: true,
				meta: {
					roles: ['USER_STORE'],
				},
			},
		],
	},
	{
		path: 'report',
		name: 'Report',
		icon: 'mdi-chart-waterfall',
		title: '報表',
		redirect: '/report/order-list',
		component: Report /* webpackChunkName: "StorePos" */,
		meta: {
			roles: ['USER_STORE'],
		},
		children: [
			{
				path: 'order-list',
				name: 'OrderList',
				title: '營業額',
				component: OrderManageList,
				hide: true,
				meta: {
					roles: ['USER_STORE'],
				},
			},
			{
				path: 'cash-drawer-record',
				name: 'CashDrawerRecord',
				title: '收支',
				component: CashDrawerRecord,
				hide: true,
				meta: {
					roles: ['USER_STORE'],
				},
			},
			{
				path: 'business-statement',
				name: 'BusinessStatement',
				title: '交班',
				component: BusinessStatement,
				hide: true,
				meta: {
					roles: ['USER_STORE'],
				},
			},
			{
				path: 'sales-ranking',
				name: 'salesRanking',
				title: '銷售排行榜',
				component: SalesRanking,
				hide: true,
				meta: {
					roles: ['USER_STORE'],
				},
			},
			{
				path: 'order-details/:orderId',
				name: 'OrderManageOrderDetails',
				component:
					OrderDetails /* webpackChunkName: "OrderManageOrderDetails" */,
				hide: true,
				meta: {
					roles: ['USER_STORE'],
				},
			},
		],
	},
	{
		path: 'menu-manage',
		name: 'MenuManage',
		icon: 'mdi-silverware-variant',
		title: '菜單管理',
		component: MenuManage,
		redirect: '/menu-manage/meals',
		meta: {
			roles: ['USER_STORE'],
		},
		children: [
			{
				path: 'meals',
				name: 'MenuManageCategory',
				icon: 'mdi-account-box',
				title: '菜單管理',
				hide: true,
				component: Meals /* webpackChunkName: "MenuManageCategory" */,
				meta: {
					roles: ['USER_STORE'],
				},
			},
			{
				path: 'category',
				name: 'MenuCategory',
				component: Category,
				title: '分類管理',
				hide: true,
				meta: {
					roles: ['USER_STORE'],
				},
			},
			{
				path: 'taste',
				name: 'MenuManageTaste',
				icon: 'mdi-account-box',
				title: '口味管理',
				hide: true,
				component: Taste /* webpackChunkName: "MenuManageTaste" */,
				meta: {
					roles: ['USER_STORE'],
				},
			},
			{
				path: 'upgrade',
				name: 'Upgrade',
				icon: 'mdi-account-box',
				title: '升級管理',
				hide: true,
				component: Upgrade /* webpackChunkName: "MenuManageComboList" */,
				meta: {
					roles: ['USER_STORE'],
				},
			},

			{
				path: 'meal/editor',
				name: 'MenuMealEditor',
				component: Editor /* webpackChunkName: "MenuMealEditor" */,
				hide: true,
				meta: {
					roles: ['USER_STORE'],
				},
			},
			{
				path: 'remark',
				name: 'Remark',
				icon: 'mdi-account-box',
				title: '備註管理',
				hide: true,
				component: Remark /* webpackChunkName: "MenuManageCategory" */,
				meta: {
					roles: ['USER_STORE'],
				},
			},
		],
	},

	{
		path: 'contractManage',
		name: 'ContractManage',
		icon: 'mdi-file-sign',
		title: '合約管理',
		redirect: '/contractManage/contract-classification',
		component: ContractManage,
		meta: {
			roles: [
				'ROLE_SUPER_SPECIAL_MANAGER',
				'USER_MANAGER',
				'USER_SALES_PERSON',
			],
		},

		children: [
			{
				path: 'contract-classification',
				name: 'ContractClassification',
				icon: 'mdi-account-box',
				title: '合約分類',
				hide: true,
				component:
					ContractClassification /* webpackChunkName: "MenuManageCategory" */,
				meta: {
					roles: [
						'ROLE_SUPER_SPECIAL_MANAGER',
						'USER_MANAGER',
						'USER_SALES_PERSON',
					],
				},
			},
			{
				path: 'add-contract',
				name: 'AddContract',
				hide: true,
				component: AddContract,
				meta: {
					roles: [
						'ROLE_SUPER_SPECIAL_MANAGER',
						'USER_MANAGER',
						'USER_SALES_PERSON',
					],
				},
			},
			{
				path: 'contract-details/:id/:tabType',
				name: 'ContractDetails',
				component: ContractDetails,
				hide: true,
				meta: {
					roles: [
						'ROLE_SUPER_SPECIAL_MANAGER',
						'USER_MANAGER',
						'USER_SALES_PERSON',
					],
				},
			},
		],
	},

	{
		path: 'announcementManager',
		name: 'AnnouncementManager',
		icon: 'mdi-bullhorn-outline',
		title: '公告管理',
		redirect: '/announcementManager/announcement',
		component: AnnouncementManager,
		meta: {
			roles: ['ROLE_SUPER_SPECIAL_MANAGER', 'USER_MANAGER'],
		},

		children: [
			{
				path: 'announcement',
				name: 'Announcement',
				icon: 'mdi-bullhorn-outline',
				title: '公告設置',
				component: Announcement,
				hide: true,
				meta: {
					roles: ['ROLE_SUPER_SPECIAL_MANAGER', 'USER_MANAGER'],
				},

				children: [
					{
						path: 'add-announcement',
						name: 'AnnouncementEditor',
						title: '公告設置',
						component: AnnouncementEditor,
						hide: true,
						meta: {
							roles: ['ROLE_SUPER_SPECIAL_MANAGER', 'USER_MANAGER'],
						},
					},
				],
			},
			{
				path: 'announcementTemplate',
				name: 'AnnouncementTemplate',
				icon: 'mdi-bullhorn-outline',
				title: '公版管理',
				component: AnnouncementTemplate,
				hide: true,
				meta: {
					roles: ['ROLE_SUPER_SPECIAL_MANAGER', 'USER_MANAGER'],
				},

				children: [
					{
						path: 'add-announcementTemplate',
						name: 'AnnouncementTemplateEditor',
						title: '公版管理',
						component: AnnouncementTemplateEditor,
						hide: true,
						meta: {
							roles: ['ROLE_SUPER_SPECIAL_MANAGER', 'USER_MANAGER'],
						},
					},
				],
			},
		],
	},

	{
		path: 'mail-history',
		name: 'MailHistory',
		icon: 'mdi-email',
		title: '郵件紀錄',
		component: MailHistory,
		meta: {
			roles: [
				'ROLE_SUPER_SPECIAL_MANAGER',
				'USER_MANAGER',
				'USER_SALES_PERSON',
			],
		},
	},

	{
		path: 'account-manage',
		name: 'AccountManage',
		icon: 'mdi-account-box',
		title: '店家管理',
		component: AccountManage,
		redirect: '/account-manage/store-set',
		meta: {
			roles: ['USER_STORE'],
		},
		children: [
			{
				path: 'user-info',
				name: 'AccountManageUserInfo',
				icon: 'mdi-account-box',
				title: '店家管理',
				component: UserInfo,
				meta: {
					roles: ['USER_STORE'],
				},
				hide: true,
			},
			{
				path: 'reset-password',
				name: 'AccountManageResetPassword',
				component: ResetPassword,
				hide: true,
				meta: {
					roles: ['USER_STORE'],
				},
			},
			{
				path: 'store-set',
				name: 'AccountManageStoreSet',
				component: StoreSet,
				title: '店家設定',
				hide: true,
				meta: {
					roles: ['USER_STORE'],
				},
			},
			{
				path: 'mobile-order-set',
				name: 'AccountManageMobileOrderSet',
				component: MobileOrderSet,
				title: '手機點餐設定',
				hide: true,
				meta: {
					roles: ['USER_STORE'],
				},
			},
			{
				path: 'invoice-set',
				name: 'AccountManageInvoiceSet',
				component: InvoiceSet,
				title: '電子發票設定',
				hide: true,
				meta: {
					roles: ['USER_STORE'],
				},
			},
			{
				path: 'delivery-platform-set',
				name: 'AccountManageDeliveryPlatformSet',
				component: DeliveryPlatformSet,
				title: '外送平台設定',
				hide: true,
				meta: {
					roles: ['USER_STORE'],
				},
			},
		],
	},
	{
		path: 'announcement-history',
		name: 'StoreAnnouncementHistory',
		icon: 'mdi-bullhorn-outline',
		title: '公告紀錄',
		hide: true,
		component: StoreAnnouncementHistory,
		meta: {
			roles: ['USER_STORE'],
		},
	},
	{
		path: 'reset-password',
		name: 'AdminResetPassword',
		icon: 'mdi-account-box',
		title: '修改密碼',
		component: AdminResetPassword,
		meta: {
			roles: [
				'ROLE_SUPER_SPECIAL_MANAGER',
				'USER_MANAGER',
				'USER_SALES_PERSON',
			],
		},
	},
	{
		path: 'userAuthManage',
		name: 'UserAuthMange',
		icon: 'mdi-account-supervisor',
		redirect: '/userAuthManage/userManage',
		title: '使用者及權限管理',
		component: UserAuthManage,
		meta: {
			roles: ['ROLE_SUPER_SPECIAL_MANAGER', 'USER_MANAGER'],
		},
		children: [
			{
				path: 'userManage',
				name: 'UserManage',
				icon: 'mdi-account-supervisor',
				title: '使用者管理',
				component: UserManage,
				hide: true,
				meta: {
					roles: ['ROLE_SUPER_SPECIAL_MANAGER', 'USER_MANAGER'],
				},
				children: [
					{
						path: 'addUser',
						name: 'UserEditor',
						title: '使用者管理',
						component: UserEditor,
						hide: true,
						meta: {
							roles: ['ROLE_SUPER_SPECIAL_MANAGER', 'USER_MANAGER'],
						},
					},
				],
			},
			{
				path: 'authManage',
				name: 'AuthManage',
				icon: 'mdi-account-supervisor',
				title: '權限管理',
				component: AuthManage,
				hide: true,
				meta: {
					roles: ['ROLE_SUPER_SPECIAL_MANAGER', 'USER_MANAGER'],
				},
				children: [
					{
						path: 'addAuth',
						name: 'AuthEditor',
						title: '權限管理',
						component: AuthEditor,
						hide: true,
						meta: {
							roles: ['ROLE_SUPER_SPECIAL_MANAGER', 'USER_MANAGER'],
						},
					},
				],
			},
		],
	},
	{
		path: 'system-setting',
		name: 'SystemSetting',
		icon: 'mdi-cog-outline',
		title: '系統設定 ',
		component: SystemSetting,
		meta: {
			roles: ['ROLE_SUPER_SPECIAL_MANAGER', 'USER_MANAGER'],
		},
	},
	{
		path: 'dev-tools',
		name: 'DevTools',
		icon: 'mdi-tools',
		title: '開發工具',
		component: DevTools,
		meta: {
			// 角色帳號也必須明確命中下列角色，不可用 role=true 的一般通道繞過
			roles: ['ROLE_SUPER_SPECIAL_MANAGER', 'USER_MANAGER'],
			strictRoles: true,
		},
	},
	{
		path: 'whats-eat-manage',
		name: 'WhatsEatManage',
		icon: 'mdi-food',
		title: '吃什麼優惠卷',
		hide: true,
		component: WhatsEatManage,
		redirect: '/whats-eat-manage/whats-eat-panel',
		meta: {
			roles: ['USER_STORE'],
		},
		children: [
			{
				path: 'whats-eat-panel',
				name: 'WhatsEatPanel',
				icon: 'mdi-account-box',
				title: '',
				hide: true,
				component: WhatsEatPanel,
				meta: {
					roles: ['USER_STORE'],
				},
			},
		],
	},
]

const routes = [
	{
		path: '/',
		name: 'Home',
		component: Home,
		children: [...adminRoutes],
		meta: {
			roles: [
				'ROLE_SUPER_SPECIAL_MANAGER',
				'USER_MANAGER',
				'USER_STORE',
				'USER_SALES_PERSON',
			],
		},
	},
	{
		path: '/login',
		name: 'Login',
		component: Login /* webpackChunkName: "Login" */,
		meta: {
			public: true,
		},
	},
]

const router = new VueRouter({ routes, mode: 'history' })

// 輔助函數：處理報表驗證碼顯示
const handleReportManagerCodeDisplay = async storeId => {
	try {
		const res = await storeHttp.getStoreConfig(storeId)
		const { switchSettings } = res.data
		const isOpen = switchSettings?.reportManagerCodeVerificationSwitch
		store.commit('setValidManagerCodeDisplay', !!isOpen)
	} catch (error) {
		console.error(error)
		store.commit('setValidManagerCodeDisplay', true)
	}
}

// 輔助函數：處理 UberEats 授權
const handleUberEatsAuthorization = async (code, storeId) => {
	const currentProtocol = window.location.protocol
	const currentPort = window.location.port
	let currentDomainAndPort = currentProtocol + '//' + window.location.hostname
	if (currentPort) {
		currentDomainAndPort = currentDomainAndPort + ':' + currentPort
	}
	const redirectUri =
		currentDomainAndPort + '/account-manage/delivery-platform-set'
	console.log('redirectUri 參數：', redirectUri)

	const data = {
		storeId,
		authorized: true,
		code,
		redirectUri,
	}

	try {
		const res = await storeHttp.getUberEatsStoreAuthorization(data)
		const { status, message } = res
		if (status) {
			store.commit('storage/setUberEatsStoreAuthorization', true)
			store.commit('showMessage', '授權成功')
		} else {
			console.log('授權失敗')
			store.commit('showMessage', { text: message })
		}
	} catch (error) {
		console.error(error)
		store.commit('showMessage', { text: error })
	}
}

// 輔助函數：檢查用戶權限
const checkUserPermission = (userRole, meta) => {
	const requiredRoles = meta?.roles
	if (!requiredRoles?.length) return false
	// 角色權限帳號：role=true 視為可進入後台；strictRoles 路由仍須明確比對角色
	if (store.state.storage.role === true && !meta?.strictRoles) {
		return true
	}
	return requiredRoles.some(role => role === userRole)
}

// 輔助函數：取得角色預設頁面
const getDefaultPathByRole = role => {
	switch (role) {
		case 'USER_SALES_PERSON':
			return '/nearly-expired'
		case 'ROLE_SUPER_SPECIAL_MANAGER':
		case 'SUPER_SPECIAL_MANAGER':
		case 'USER_MANAGER':
		case 'USER_SUPER_MANAGER':
			return '/store-manage'
		case 'USER_STORE':
			return resolveStoreDefaultPath()
		default:
			// 角色權限帳號：依 permissionList 決定預設頁
			if (store.state.storage.role === true) {
				return (
					getDefaultPathByPermissions(store.state.storage.permissions) || '/'
				)
			}
			return '/'
	}
}

const resolveStoreDefaultPath = () => {
	const { manager, systemModule } = store.state.storage || {}
	const posSwitch = systemModule?.posOrder
	const prefersPos =
		!manager && posSwitch && window.innerWidth > window.innerHeight
	return prefersPos ? '/store-pos' : '/order-manage/socket'
}

// 輔助函數：決定導航目標
const getNavigationTarget = (hasPermission, userRole, currentPath) => {
	if (hasPermission) return null // 通過

	if (currentPath === '/' && userRole) {
		return getDefaultPathByRole(userRole) || '/'
	}

	if (userRole && currentPath !== '/') return '/' // 有角色但無權限，跳轉首頁
	return '/login' // 無角色或已在首頁但無權限，跳轉登入
}

router.beforeEach(async (to, from, next) => {
	// 記下 navigation 目標，供 lazy chunk 載入失敗時導向用
	setPendingNavigationTarget(to.fullPath)

	try {
		await bootGate.whenReady('main.js') // 等初始化開門（逾時會丟 GATE_TIMEOUT）
	} catch (e) {
		console.log(e)
	}

	const fromFullPath = from.fullPath || '/'
	store.commit('setFromRoutePath', fromFullPath)

	const token = store.state.storage.token
	const isLoginRoute = to.path === '/login'
	const isRefreshRoute = to.path.startsWith('/Refresh/')
	const isPublicRoute = to.meta?.public || isRefreshRoute || isLoginRoute

	if (!token) {
		// 身份失效即將離開目前畫面，清除所有 owner/token 與計時器
		loader.clearAll()
		if (isPublicRoute) {
			next()
		} else {
			next('/login')
		}
		return
	}

	const { manager, role, storeId, switchRole, permissions, loginRole } =
		store.state.storage

	// 僅店家前後台權限的角色帳號未選店家時：不可進入店家路徑，導向首頁選店家
	const isStoreOnlyRoleWithoutStore =
		role === true && !hasAnyBackendOperation(permissions || []) && !storeId
	const storePaths = [
		'/store-pos',
		'/order-manage',
		'/report',
		'/menu-manage',
		'/account-manage',
		'/announcement-history',
		'/whats-eat-manage',
	]
	const accountManagePathsWithoutStore = [
		'/account-manage/store-set',
		'/account-manage/user-info',
	]
	const isAllowedPathWithoutStore = accountManagePathsWithoutStore.some(
		p => to.path === p || to.path.startsWith(p + '/'),
	)
	const isStorePath = path =>
		storePaths.some(prefix => path === prefix || path.startsWith(prefix + '/'))
	if (
		isStoreOnlyRoleWithoutStore &&
		to.path !== '/' &&
		isStorePath(to.path) &&
		!isAllowedPathWithoutStore
	) {
		next('/')
		return
	}

	if (isLoginRoute) {
		// 只要有 token，就阻止訪問登入頁
		if (fromFullPath && fromFullPath !== '/login') {
			next(fromFullPath)
			return
		}
		// 如果 fromFullPath 無效，導向角色預設頁或首頁
		const fallback =
			role === true
				? getDefaultPathByPermissions(permissions) || '/'
				: switchRole
				? getDefaultPathByRole(switchRole)
				: '/'
		next(fallback)
		return
	}

	if (isRefreshRoute) {
		next()
		return
	}

	if (manager || role) {
		store.commit('setValidManagerCodeDisplay', false)
	} else if (storeId) {
		const isEnteringReport =
			!from.path.startsWith('/report') && to.path.startsWith('/report')
		if (isEnteringReport) {
			handleReportManagerCodeDisplay(storeId)
		}

		const isUberEatsCallback =
			to.path.startsWith('/account-manage/delivery-platform-set') &&
			Object.prototype.hasOwnProperty.call(to.query, 'code')
		if (isUberEatsCallback) {
			handleUberEatsAuthorization(to.query.code, storeId)
		}
	}

	const isLeavingMenuManage =
		from.path.startsWith('/menu-manage') && !to.path.startsWith('/menu-manage')
	if (isLeavingMenuManage) {
		store.commit('setMenuCategoryId', 0)
	}

	const isEnteringOrderManage =
		!from.path.startsWith('/order-manage') &&
		to.path.startsWith('/order-manage')
	if (isEnteringOrderManage) {
		store.commit('setOrderManagerRedTag', false)
	}

	const hasPermission = checkUserPermission(switchRole, to.meta)
	if (!hasPermission) {
		const navigationTarget = getNavigationTarget(
			hasPermission,
			switchRole,
			to.path,
		)
		next(navigationTarget)
		return
	}

	if (to.path === '/' && switchRole) {
		// 僅店家前後台權限且未選店家：停留在 / 顯示「請選擇店家」
		if (isStoreOnlyRoleWithoutStore) {
			next()
			return
		}
		const roleDefaultPath =
			role === true
				? getDefaultPathByPermissions(permissions) || '/'
				: getDefaultPathByRole(switchRole)
		if (
			roleDefaultPath &&
			roleDefaultPath !== '/' &&
			roleDefaultPath !== to.path
		) {
			next(roleDefaultPath)
			return
		}
	}

	next()
})

router.afterEach(() => {
	clearPendingNavigationTarget()
	// 換頁安全網：每次路由切換完成後，強制關閉殘留的全螢幕 loading 遮罩，
	// 避免任何漏掉 hide 的呼叫端讓遮罩跨頁卡住。
	loader.clearAll()
})

// vue-router 3：lazy component import 失敗時會觸發 router.onError
router.onError(error => {
	handleChunkLoadError(error)
})

export default router
